import React from "react";
import { useAuthContext } from "../context/AuthContext";
import { useTestContext } from "../context/TestContext";

const productType = [
	{ title: "Home", value: "Home" },
	{ title: "Tests", value: "Test" },
	{ title: "Packages", value: "Package" },
	{ title: "Radiology", value: "Radiology" },
];

const ProductTypeSelector = () => {
	const { scrollDirection } = useAuthContext();
	const { selectedProductType, setSelectedProductType } = useTestContext();

	return (
		<div
			className={`w-full h-fit bg-whiteColor justify-center items-center p-[3%] lg:p-[2%] hidden lg:flex lg:sticky ${
				scrollDirection === "up"
					? "top-[75px] lg:top-[107px]"
					: "top-[75px] lg:top-[66px]"
			} z-40`}>
			<div className='w-full lg:w-[33%] h-fit bg-[#E3E3E3] flex justify-between items-center border rounded-full'>
				{productType?.map((item, index) => {
					return (
						<button
							key={index}
							className={`${
								item.value === selectedProductType
									? "bg-primaryColor text-whiteColor rounded-full"
									: "bg-[#E3E3E3] text-textSecondaryColor rounded-full"
							} px-[5%] py-[3%] lg:py-[2.5%] font-normal text-[3.5vw] lg:text-[1vw] whitespace-nowrap`}
							onClick={() => setSelectedProductType(item.value)}>
							{item.title}
						</button>
					);
				})}
			</div>
		</div>
	);
};

export default ProductTypeSelector;
